<template>
	<div>
		<svg
			:width="iconSize"
			:height="iconSize"
			viewBox="0 0 25 26"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M22.6562 7.53125C22.6562 10.1201 20.5576 12.2188 17.9688 12.2188C17.834 12.2188 17.7005 12.2131 17.5686 12.2019C16.4484 12.1072 15.21 12.2763 14.4953 13.1441L7.04617 22.1895C6.54205 22.8016 5.79059 23.1562 4.99759 23.1562C3.53191 23.1562 2.34375 21.9681 2.34375 20.5024C2.34375 19.7094 2.69838 18.958 3.31052 18.4538L12.3559 11.0047C13.2237 10.29 13.3928 9.05162 13.2981 7.93136C13.2869 7.79947 13.2812 7.66603 13.2812 7.53125C13.2812 4.94242 15.3799 2.84375 17.9688 2.84375C18.6566 2.84375 19.3099 2.99191 19.8983 3.25806L16.4856 6.6708C16.7524 7.83295 17.6672 8.74776 18.8293 9.01455L22.242 5.60186C22.5081 6.19029 22.6562 6.84347 22.6562 7.53125Z"
				:stroke="color"
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M5.07004 20.4219H5.07785V20.4297H5.07004V20.4219Z"
				:stroke="color"
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</svg>
	</div>
</template>

<script>
export default {
	name: 'IconSvgWrench',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		size: {
			type: Number,
			default: null,
		},
	},
	computed: {
		iconSize() {
			return this.size ? `${this.size}px` : '44px'
		},
	},
}
</script>

<style scoped></style>
